import { Client } from '@revenuegrid/churnzerojs';
import {
  productionSecretKey,
  developSecretKey,
  apiClientUrl
} from '@helpers/constants';

const churnZeroInitialize = async (currentUser) => {
  if (!currentUser) return;

  const isLocalEnv = window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1');

  if (isLocalEnv) return;

  const property = currentUser.managedProperties[0];
  const { company } = currentUser;
  const accountId = property ? property.id : company.id;

  if (!accountId) return;

  const isProduction = window.location.host === 'realync.com';

  const apiKey = isProduction ? productionSecretKey : developSecretKey;

  await Client.connect({
    url: apiClientUrl,
    apiKey,
    accountId,
    contactId: currentUser.id
  });
};

export default churnZeroInitialize;
